export default {
  root: {
    margin: 0,
    height: "130px",
    display: "flex",
  },
  center: {
    margin: "auto",
    textAlign: "center",
  },
  title: {
    textAlign: "center",
    width: "calc(100% - 50px)"
  },
  centerContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  closeButton: {
    marginTop: "5px",
    color: "#F54040",
    background: "#F4F4F4",
  },
  actions: {
    flexDirection: "row",
    display: "flex",
  },
  deleteImageDiv: {
    width: "25px",
    height: "25px",
    background: "#000",
    opacity: 0.8,
    borderRadius: "50%",
    marginLeft: "42px",
    marginTop: "4px",
  },
  deleteImage: {
    marginLeft: "1px",
    marginTop: "3px",
    width: "13px",
  },
  content: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "0px",
    overflow: "none",
    padding: 0
  },
};
